export const STRING_DECAMELIZE_REGEXP = /(?<lowercaseLetter>[a-z\d])(?<uppercaseLetter>[A-Z])/g;

/**
 * Converts a camelized string into all lower case separated by underscores.
 * @param entry - The string to decamelize
 * @returns The decamelized string
 * @example
 * decamelize('fooBar') // returns 'foo_bar'
 */
export const decamelize = (entry: string): string =>
  entry.replace(STRING_DECAMELIZE_REGEXP, '$<lowercaseLetter>_$<uppercaseLetter>').toLowerCase();
